import React, { Component } from 'react';
import { connect } from 'react-redux';
import Media from 'react-media';
import classes from './HotelSummary.scss';

import ButtonProceed from '../../UI/Button/ButtonProceed/ButtonProceed';
import Button from '../../UI/Button/Button';
import CheckBox from '../../UI/CommonCheckBox/CommonCheckBox';
import InputMaterial from '../../UI/InputMaterial/InputMaterial';
import HeadingH3 from '../../UI/Headings/HeadingH3/HeadingH3';

import closeIcon from '../../../assets/images/close-icon.svg';

import { updateMarkup } from '../../../store/actions/index';

class HotelSummary extends Component {

    state = {
        isSetMarkup: false,
        markupAmount: 0,
        isAgentProfit: true
    }

    toggleSetMarkupHandler = () => {
        this.setState(prevState => {
            return { isSetMarkup: !prevState.isSetMarkup  }
        })
    }

    inputChangeHandler = (event) => {
        const target = event.target;
        const name = target.name;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({
            [name]: value
        });
    }

    setMarkupHandler = () => {
        const queryParams = [];

        queryParams.push('priceId=' + this.props.priceId);
        queryParams.push('displayMarkupValue=' + this.state.markupAmount);
        
        const queryString = queryParams.join("&");
        this.props.onUpdateMarkup(queryString);

        this.setState(prevState => {
            return { isSetMarkup: !prevState.isSetMarkup  }
        })
    }

    render() {
        let subFareBreakup = [];
        for(let i = 0; i < this.props.fareBreakup.length; i++) {
            if(this.props.fareBreakup[i].label === "Total") {
                break;
            }
            if(this.props.fareBreakup[i].value !== 0) {
                subFareBreakup.push(
                    <p key={i} className={`${classes.Para} mb-3`}>
                        <span>{this.props.fareBreakup[i].label}</span> 
                        <span>&#8377; {this.props.fareBreakup[i].value.toLocaleString()}</span>
                    </p>
                );
            }
        }

        return (
            <React.Fragment>
                <div className={classes.Container}>
                    <div style={{display: this.props.reviewPrimary === "payments" ? 'none' : 'flex'}} className={`pl-6 pr-6 align-items-center u-flex justify-content-between u-backgroundColorWhite u-relative u-phoneShow`}>
                        <h2 className={classes.HeadingMain}>{ this.props.isPromoActive ? 'Choose Promo' : 'Fare Details' }</h2>
                        {
                            this.props.mobileFareBreakup ? <div className={classes.CloseImage} onClick={() => this.props.onToggleMobileFareBreakup()}>
                                <img src={closeIcon} alt='Close'/>
                            </div> : null
                        }
                    </div>
                    <div style={{justifyContent: this.props.reviewPrimary === "payments" ? 'flex-start' : 'space-between'}} className={classes.ContainerInner}>
                        <div style={{
                            transform: this.props.isPromoActive ? 'translateY(-14.6rem)' : 'translateY(0)',
                            transition: 'all .4s ease-in-out',
                            zIndex: '9',
                            position: 'relative',
                            maxHeight: '480px'}}>
                            <div className="u-flex justify-content-between mb-4">
                                <div><p className="u-fontSize18 u-textColorDark">Fare Details</p></div>
                                <div className="u-flex align-items-center">
                                    <CheckBox checkboxtype='square' onChange={this.inputChangeHandler} name='isAgentProfit' checked={this.state.isAgentProfit} />
                                    <div className={`ml-2`}>
                                        { this.state.isSetMarkup ? <Button theme='OutlinePrimary' type="Markup" onClick={() => this.toggleSetMarkupHandler()}>Close</Button> : <Button theme='OutlinePrimary' type='Markup' onClick={() => this.toggleSetMarkupHandler()}>Set Markup</Button> }
                                    </div>
                                </div>
                            </div>
                            {
                                !this.state.isSetMarkup ? 
                                <React.Fragment>
                                    <div>{subFareBreakup}</div>
                                    <div className={classes.CustomDivider} />
                                    {
                                        this.state.isAgentProfit ? 
                                        <div style={{display: this.props.reviewPrimary === "payments" ? 'none' : 'block'}} className={classes.WhiteBackground}>
                                            <div>
                                                <p className={`${classes.Para} u-fontSize16 mb-2`}>
                                                    <span className="u-fontSize16">Total</span>
                                                    <span className="u-fontSize16">&#8377; {this.props.fareBreakup.find(fareObj => fareObj.key === "total").value.toLocaleString()}</span>
                                                </p>
                                                <p className={`${classes.Para} mb-3`}>
                                                        <span>{this.props.fareBreakup.find(fareObj => fareObj.key === "agentProfit").label}</span>
                                                        <span>&#8377; {this.props.fareBreakup.find(fareObj => fareObj.key === "agentProfit").value.toLocaleString()}</span>
                                                </p>
                                                <p className={`${classes.Para}`}>
                                                    <span>{this.props.fareBreakup.find(fareObj => fareObj.key === "TDS").label}</span>
                                                    <span>&#8377; {this.props.fareBreakup.find(fareObj => fareObj.key === "TDS").value.toLocaleString()}</span>
                                                </p>
                                            </div>
                                        </div> : null
                                    }
                                </React.Fragment>
                                : 
                                <React.Fragment>
                                    <div className={`mb-5 mt-8`}>
                                        <InputMaterial 
                                            type='number'
                                            label='Set Markup Amount' 
                                            alignment='left' 
                                            maxLength="10" 
                                            value={this.state.markupAmount} 
                                            onChange={this.inputChangeHandler} 
                                            name='markupAmount' />
                                    </div>
                                    <Button onClick={this.setMarkupHandler} theme="OutlinePrimary" width="Block" type="MarkupLarge">SET MARKUP NOW</Button>
                                </React.Fragment>
                            }
                        </div>
                        {
                            !this.state.isSetMarkup ? 
                            <div>
                                <div className={`u-flex justify-content-between align-items-center mb-4`}>
                                    <HeadingH3 size={26} weight="Medium" color="Dark">{ this.state.isAgentProfit ? 'Net Fare' : 'Total' }</HeadingH3>
                                    <HeadingH3 size={26} weight="Medium" color="Dark">&#8377;{this.props.fareBreakup.find(fareObj => fareObj.key === (this.state.isAgentProfit ? "netFare" : "total")).value.toLocaleString()}</HeadingH3>
                                </div>
                                <div style={{display: this.props.reviewPrimary === "payments" ? 'none' : 'block'}}>
                                    <Media query="(min-width: 599px)">
                                    { matches => matches ? <ButtonProceed onClick={this.props.payButtonHandler} isactive={ this.props.reviewPrimary === "review" ? true : this.props.isPaymentButtonActive}>Proceed To Pay</ButtonProceed> : null }
                                    </Media>
                                </div>
                            </div> : null
                        }
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        fareBreakup: state.hotels.reviewFareBreakUp,
        reviewPrimary: state.ui.reviewPrimary,
        priceId: state.hotels.reviewPriceId
    }
}

const mapDispatchToProps = dispatch => {
    return {
      onUpdateMarkup: (markupParams) => dispatch(updateMarkup(markupParams))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(HotelSummary);


// WEBPACK FOOTER //
// ./src/components/Hotel/HotelSummary/HotelSummary.js